import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import { ModalComponent } from 'src/app/comunes/modal/modal.component';

import { AuthService } from 'src/app/auth/auth.service';
import { Grupo } from 'src/app/models/grupo.models';
import { GruposService } from '../grupos.service';

@Component({
  selector: 'app-dashboard-grupos',
  templateUrl: './dashboard-grupos.component.html',
  styleUrls: ['./dashboard-grupos.component.scss']
})
export class DashboardGruposComponent implements OnInit {

  grupos: Array<Grupo> = [];
  total: number = 0;
  modalRef: MDBModalRef;
  limit: number = 10;
  skip: number = 0;

  constructor(
    private authService: AuthService,
    private gruposService: GruposService,
    private toastService: ToastService,
    private modalService: MDBModalService,
  ) { }

  ngOnInit(): void {
  }

  getGrupos(): void {
    const options = {
      skip: this.skip,
      limit: this.limit
    };
    this.gruposService.getGrupoCount().subscribe(
      resumen => this.total = resumen.total
    );
    this.gruposService.getGrupos(options).subscribe(
      grupos => this.grupos = grupos
    );
  }

  onChangePage(event) {
    this.limit = event.limit;
    this.skip = event.skip;
    this.getGrupos();
  }

  openModal(id: string, nombre: string) {
    const options = {
      data: {
        heading: 'Grupos',
        content: { heading: nombre, description: '¿Desea eliminar este grupo?'}
      }
    }
    this.modalRef = this.modalService.show(ModalComponent, options);
    this.modalRef.content.action.subscribe((result: any) => {
      if (result)
        this.gruposService.deleteGrupo(id).subscribe(
          doc => {
            if (doc) {
              this.toastService.success('El grupo fue eliminado correctamente');
              this.getGrupos();
            } else {
              this.toastService.error(`No pudo realizarse la operación solicitada`);
            }
          }
        );
      this.modalRef.hide();
    });
  }
  get isSuperAdmin() {
    return this.authService.isSuperAdmin();
  }

  get isAdmin() {
    return this.authService.isSuperAdmin() || this.authService.isAdmin();
  }
}
